import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { COLLEGE } from "../lib/data";

export default function Footer() {
  return (
    <footer className="mt-10 border-t border-slate-200/70 bg-[#F3ECD3]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="md:col-span-2">
          <div className="font-display text-xl font-semibold text-cct-blue">
            {COLLEGE.legalName}
          </div>
          <p className="mt-3 text-sm text-slate-600 max-w-md leading-relaxed">
            Cambridge College Admission Portal — apply as a student, partner
            as a recruiter, or sign in as staff to manage admissions.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">
            Contact
          </div>
          <div className="mt-3 space-y-2 text-sm text-slate-700">
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-cct-blue" /> {COLLEGE.email}
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-cct-blue" /> {COLLEGE.phone}
            </div>
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-cct-blue mt-0.5" />
              <div>
                {COLLEGE.campuses.map((c) => (
                  <div key={c}>{c}</div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold">
            Portal
          </div>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <Link to="/apply" className="text-slate-700 hover:text-cct-blue">
                Apply Now
              </Link>
            </li>
            <li>
              <Link
                to="/apply/domestic"
                className="text-slate-700 hover:text-cct-blue"
              >
                Domestic Application
              </Link>
            </li>
            <li>
              <Link
                to="/recruiter-signup"
                className="text-slate-700 hover:text-cct-blue"
              >
                Recruiter Sign Up
              </Link>
            </li>
            <li>
              <Link
                to="/admin-login"
                className="text-slate-700 hover:text-cct-blue"
              >
                Admin Login
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <div>
            © {new Date().getFullYear()} {COLLEGE.legalName}. All rights reserved.
          </div>
          <div>Secure portal · SSL encrypted · Data handled per privacy policy</div>
        </div>
      </div>
    </footer>
  );
}
